<script>
    export let activity={};
    import {Input,Button} from 'sveltestrap'
    import { createEventDispatcher } from 'svelte';
    import DB from "./DB/DB.svelte"
    const dispatch = createEventDispatcher();

    function close(){
        dispatch("close",{})
    }

    let sub="db";
    let player;

    function play(e){
        player.src=e.detail.audio
        player.load();
        player.play()
    }
</script>

<div style="width:100%;height:42px;">
    <Input type="select" bind:value={sub} style="width:250px;float:left">
        <option value={undefined}>раздел...</option>
        <option value={"db"}>бд</option>
    </Input>
    <audio style="width:300px;height:30px;float:left;margin-left:15px;" 
                controls="controls"
                bind:this={player} ></audio>
    <Button color="dark" style="float:right" outline on:click={()=>{close()}}>Закрыть</Button>
</div>
{#if sub=="db"}
    <DB bind:activity on:play={play}/>
{/if}